export default "__VITE_ASSET__1443b8d2__"